<template>
    <div>
        <div v-if="reports?.length" class="flex items-center space-x-1.5 leading-5">
            <p v-if="regularReportsCount">{{ regularReportsCount }}</p>
            <span v-if="regularReportsCount && hasFeedback">+</span>
            <UBadge v-if="hasFeedback" color="orange" label="F" variant="solid" />
        </div>
        <span v-else class="text-gray-300">–</span>
    </div>          
</template>

<script setup lang="ts">
import { FEEDBACK_REPORT_REASON_ID } from '~/types/call'

const props = defineProps<{
    reports?: { id: string, call_reason_id: string }[]
}>()

const regularReportsCount = computed(() => props.reports?.filter((report) => report.call_reason_id !== FEEDBACK_REPORT_REASON_ID).length)
const hasFeedback = computed(() => props.reports?.some((report) => report.call_reason_id === FEEDBACK_REPORT_REASON_ID))
</script>
